export default __webpack_public_path__ + "static/media/T240MANC1.2445df0c.pdf";